module.exports = __webpack_public_path__ + "img/portrait.02d517bc.png";